import React, { Component, FormEvent } from 'react';
import { NotificationManager } from 'react-notifications';
import { Button, Spinner } from 'react-rainbow-components';

import { faRedo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AxiosResponse } from 'axios';

import { Message, MessageProps, Typing } from '../../components';
import { BOT_NAME, USER_NAME } from '../../constants';
import { delay, generateUniqueId, getMessagesFromText } from '../../helpers/utils';
import { createSession, sendMessage } from '../../services/chatbot';
import VocationalTest from '../VocationalTest';

import './styles.scss';

interface State {
  isFinished: boolean;
  isTyping: boolean;
  isVocationalTest: boolean;
  loading: boolean;
  messages: MessageProps[];
  userMessage: string;
}

export default class Chat extends Component {
  private messagesEndRef = React.createRef<HTMLDivElement>();

  state: Readonly<State> = {
    isFinished: false,
    isVocationalTest: true,
    isTyping: false,
    loading: true,
    messages: [],
    userMessage: ''
  }

  async componentDidMount(): Promise<void> {
    try {
      await createSession();
      this.setState({ loading: false });
    } catch (error) {
      NotificationManager.error(`Não foi possível comunicar-se com o ${BOT_NAME} no momento, tente novamente mais tarde.`);
      console.log(error);
    }
  }

  getMessages = async (response: AxiosResponse): Promise<void> => new Promise(async (resolve) => {
    (async () => {
      const { generic } = response.data.output;
      for (const { source, text, ...rest } of generic) {
        if (rest.response_type === 'text') {
          const botMessages = getMessagesFromText(text);
          for (const [botMessage, messageDelay] of botMessages) {
            this.setState({ isTyping: true });
            await delay(messageDelay);
            this.setState((prevState: State) => ({
              isTyping: false,
              messages: [
                ...prevState.messages,
                botMessage
              ]
            }));
          }
        } else if (rest.response_type === 'image') {
          this.setState((prevState: State) => ({
            messages: [
              ...prevState.messages,
              {
                date: new Date(),
                id: generateUniqueId(),
                imageUrl: source,
                name: BOT_NAME,
                owner: 'bot'
              }
            ]
          }));
        }
      }
      resolve();
    })();
  });

  handleResult = async (messages: AxiosResponse[]): Promise<void> => {
    this.setState({ isVocationalTest: false });
    for (const message of messages) {
      await this.getMessages(message);
    }
    this.setState({ isFinished: true });
  }

  handleSubmit = async (e: FormEvent): Promise<void> => {
    try {
      e.preventDefault();
      const { messages, userMessage } = this.state;
      if (userMessage.trim()) {
        messages.push({
          date: new Date(),
          id: generateUniqueId(),
          name: USER_NAME,
          owner: 'user',
          text: userMessage
        });
        this.setState({ messages, userMessage: '' });
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        this.messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
        await this.sendMessage(userMessage);
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        this.messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
      }
    } catch (error) {
      NotificationManager.error('Não foi possível enviar sua mensagem no momento, tente novamante mais tarde.');
      console.log(error);
    }
  }

  sendMessage = async (message: string): Promise<void> => {
    const response = await sendMessage(message);
    this.getMessages(response);
  }

  render(): JSX.Element {
    const {
      isFinished,
      isTyping,
      isVocationalTest,
      loading,
      messages,
      // userMessage
    } = this.state;

    if (!loading) {
      return (
        <section className="msger">
          {/* <header className="msger-header">
            <span style={{ color: 'darkslateblue', fontSize: 18, textDecorationLine: 'underline' }}>
              Teste Vocacional | UniLaSalle - Lucas
            </span>
          </header> */}
          <div className="msger-chat">
            {
              isVocationalTest && (
                <VocationalTest onResult={this.handleResult} />
              )
            }
            {
              messages.map(({
                date,
                id,
                imageUrl,
                name,
                owner,
                text
              }) => (
                <Message
                  date={date}
                  id={id}
                  imageUrl={imageUrl}
                  key={id}
                  name={name}
                  owner={owner}
                  text={text}
                />
              ))
            }
            <div ref={this.messagesEndRef} />
            {
              isTyping && (
                <Typing name={BOT_NAME} />
              )
            }
            {
              isFinished && (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <Button onClick={() => window.location.reload()} variant="brand">
                    Refazer&nbsp;
                    <FontAwesomeIcon icon={faRedo} />
                  </Button>
                </div>
              )
            }
          </div>
          {/* <form className="msger-inputarea" onSubmit={this.handleSubmit}>
            <input
              className="msger-input"
              disabled
              onChange={(e) => this.setState({ userMessage: e.target.value })}
              placeholder="Digite sua mensagem..."
              type="text"
              value={userMessage}
            />
            <button className="msger-send-btn" disabled type="submit">Enviar</button>
          </form> */}
          <section className="bg" style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <div style={{ display: 'block', paddingRight: 10 }}>
              <a
                href="https://www.unilasalle.edu.br/lucas-do-rio-verde/servicos/grupo-de-projetos-em-solucoes-para-o-agronegocio-e-tecnologia-da-informacao"
                rel="noreferrer"
                style={{ textDecoration: 'none' }}
                target="_blank"
              >
                <span style={{ color: '#bcd', fontSize: 11 }}>Desenvolvido por:</span>
                <br/>
                <img alt="gpsati-logo" src={require('../../assets/images/gpsati-logo.png')} style={{ height: 'auto', width: 85 }} />
              </a>
            </div>
          </section>
        </section>
      );
    }

    return (
      <div>
        <Spinner />
      </div>
    );
  }
}
